
import { useState } from 'react'
import { Button, Input } from '../ui'
import { askGemini } from '../../lib/gemini'
import { Sparkles, Palette, Loader2, Check } from 'lucide-react'

export const AIStylingDesigner = ({ onApplyTheme }) => {
    const [prompt, setPrompt] = useState('')
    const [loading, setLoading] = useState(false)
    const [result, setResult] = useState(null)

    const generateTheme = async () => {
        if (!prompt) return
        setLoading(true)
        setResult(null)

        try {
            const systemPrompt = `
            Je bent een professionele webdesigner.
            Op basis van de input ontvang ik graag een hoofdkleur (HEX) voor een moderne sportwebsite.
            Input: "${prompt}"
            
            Antwoord UITSLUITEND met ruwe JSON (geen markdown):
            {
                "color": "#HEXCODE",
                "explanation": "Korte uitleg waarom dit past"
            }
            `

            const responseText = await askGemini(systemPrompt)
            // Strip potential markdown code blocks
            const cleanText = responseText.replace(/```json/g, '').replace(/```/g, '').trim()
            const data = JSON.parse(cleanText)

            if (data.color) {
                setResult(data)
            } else {
                throw new Error("Geen geldige kleur ontvangen")
            }

        } catch (err) {
            console.error(err)
            alert("Sorry, ik kon geen thema genereren. Probeer iets specifiekers.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl p-6 text-white shadow-xl mb-8 relative overflow-hidden group">
            {/* Background decoration */}
            <div className="absolute top-0 right-0 p-4 opacity-10 transform translate-x-1/2 -translate-y-1/2">
                <Sparkles size={150} />
            </div>

            <div className="relative z-10">
                <h3 className="text-xl font-bold mb-2 flex items-center gap-2">
                    <Sparkles className="text-yellow-300" />
                    AI Styling Coach
                </h3>
                <p className="text-indigo-100 mb-6 max-w-xl">
                    Geen inspiratie? Vertel mij waar je toernooi over gaat (bijv. "Koningsdag", "FC Barcelona", "Zomers strandfeest") en ik kies de perfecte kleur.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 max-w-2xl bg-white/10 p-2 rounded-xl border border-white/20 backdrop-blur-sm">
                    <input
                        type="text"
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                        placeholder="Bijv. Neon Cyberpunk of Oranje Leeuwinnen"
                        className="flex-1 bg-transparent border-none text-white placeholder:text-gray-300 focus:ring-0 px-4 py-2 outline-none"
                    />
                    <Button
                        onClick={generateTheme}
                        disabled={loading || !prompt}
                        className="bg-white text-indigo-600 hover:bg-gray-100 font-bold shadow-md whitespace-nowrap"
                    >
                        {loading ? <Loader2 className="animate-spin" /> : <Palette size={18} className="mr-2" />}
                        Ontwerp
                    </Button>
                </div>

                {/* Result Preview */}
                {result && (
                    <div className="mt-6 flex items-center gap-4 animate-slideDown bg-white/95 text-gray-800 p-4 rounded-xl shadow-lg max-w-md">
                        <div
                            className="w-16 h-16 rounded-full shadow-inner border-4 border-white shrink-0 transition-transform hover:scale-110 cursor-pointer"
                            style={{ backgroundColor: result.color }}
                            title={result.color}
                        />
                        <div className="flex-1 min-w-0">
                            <h4 className="font-bold text-gray-900">{result.color}</h4>
                            <p className="text-xs text-gray-500 line-clamp-2">{result.explanation}</p>
                        </div>
                        <Button
                            size="sm"
                            onClick={() => {
                                onApplyTheme(result.color)
                                setResult(null)
                                setPrompt('')
                            }}
                            className="bg-green-600 hover:bg-green-700 text-white shrink-0"
                        >
                            <Check size={16} className="mr-1" /> Gebruik
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}
